import React, { useState } from "react";
import Button from "@mui/material/Button";
import backArrowIcon from "../../assets/new icons/extraction review/back arrow.svg";

import InstaColors, { countries, fontFamily, useSharedValue } from "../Constants/constants";
import deleteIcon from "../../assets/new icons/trash.svg";
import refreshIcon from "../../assets/new icons/extraction review/refresh.svg";
import { DownloadExcelFile, ExcelIcon, WordIcon, ViewPDf, formatDate } from "../../Utility/utility";
import SecureDocumentViewer from "../WorkLoade_File_Import/SecureDocumentViewer";
import { getMatchRowStyle } from "../../services/MatchingEntityService";
import { validateField } from "../Constants/validationRules";
import { countriesWithStates, isValidStateForCountry } from "../Constants/countrisStatesList";
import {
  allSheetNames,
  chapter4StatusOptions,
  entityClassificationOptions,
  entityTypeOptions,
  formsTypeList,
  incomeCodesDropDownList,
} from "../list";
import { getFormFieldOrder, sortByFieldOrder } from "../../Forms/formFieldOrder";
import DataValidationLegend from "./legend";

const formatFieldNameForDisplay = (fieldName) => {
  if (!fieldName) return "";
  // Split on underscores/hyphens, then insert space before each uppercase letter
  // that follows a lowercase letter or digit (camelCase / PascalCase splitting)
  const formattedFieldName = fieldName
    .replace(/[_-]/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return formattedFieldName
    .replace(/\bW\s*9\b/gi, "W-9")
    .replace(/\bW\s*8\s*BEN\s*E\b/gi, "W-8BEN-E")
    .replace(/\bW\s*8\s*BENE\b/gi, "W-8BEN-E")
    .replace(/\bW\s*8\s*BEN\b/gi, "W-8BEN")
    .replace(/\bW\s*8\s*IMY\b/gi, "W-8IMY")
    .replace(/\bW\s*8\s*ECI\b/gi, "W-8ECI")
    .replace(/\bW\s*8\s*EXP\b/gi, "W-8EXP")
    .replace(/\bGIIN\b/gi, "GIIN")
    .replace(/\bEIN\b/gi, "EIN")
    .replace(/\bTIN\b/gi, "TIN")
    .replace(/\bUS\b/gi, "US");
};

export default function DataValidationPopup({
  open,
  onClose,
  rows,
  selectedCheckbox,
  runValidation,
  setOnClickValue,
  selectSheet,
  handleSelectSheetProcess,
  extractedValidatedata,
  formTypesWithCount = [],
  formTypeIndices = {},
  selectedIndex,
  setSelectedIndex,
  viewMode,
  setViewMode,
  handleSaveChanges,
  handleFileUpload,
  handleExcelAuditReport,
  handleDeleteRow,
  handleAddEmptyRow,
  handleAddMatchingRow,
  handleDropdownChange,
  matchedEntitiesData,
  shouldHighlightRow,
  handleSelectedSheet,
  rowHasErrors,
  columnHasErrors,
  getIdDocumentType,
  getFormTypeDisplayName,
  halfWidth,
  isFormTypeWithToggle,
  getForm,
  setIsModalOpen,
  setColumnName,
  setEditValue,
  setOldValue,
  setRowIndex,
  handleSaveEditData,
  onAddNote,
  actionColumnWidth = 52,
}) {
  const { isMenuOpen } = useSharedValue();
  const [showOnlyErrors, setShowOnlyErrors] = useState(false);
  const [showOnlyErrorColumns, setShowOnlyErrorColumns] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoverValue, sethoverValue] = useState(false);
  const [hoverIndexValue, setHoverIndexValue] = useState(null);
  const [showLegend, setShowLegend] = useState(false);
  const [hideNonMandatoryColumns, setHideNonMandatoryColumns] = useState(false);

  const mandatoryColumnFields = new Set([
    "UniqueIdentifier",
    "Entity Type",
    "FirstName",
    "LastName",
    "Business Name",
    "BusinessUnit",
  ]);

  if (!open) return null;

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        minHeight: 0,
        padding: 10,
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "row",
          alignItems: "center",
          marginLeft: 10,
          marginTop: 10,
        }}
      >
        <img
          src={backArrowIcon}
          alt="Back"
          title="Return"
          onClick={onClose}
          style={{
            width: 22,
            height: 22,
            cursor: "pointer",
            marginRight: 10,
            flexShrink: 0,
          }}
        />
        <div
          style={{
            color: "#3B3B3B",
            fontFamily: fontFamily,
            fontWeight: 500,
            marginRight: 15,
            margin: 0,
            marginRight: 15,
            lineHeight: 1,
          }}
        >
          Data Validation Check :&nbsp;
        </div>
        <div
          style={{
            color: "#3B3B3B",
            fontWeight: 300,

            fontFamily: fontFamily,
            marginRight: "auto",

            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {rows.find((item) => item.fileImportId === selectedCheckbox)?.fileName || ""}
        </div>

        {selectedCheckbox !== null && (
          <div style={{ marginRight: 10 }}>
            {" "}
            <DownloadExcelFile
              fileName={rows.find((item) => item.fileImportId === selectedCheckbox)?.fileImportId}
              businessunit={
                rows.find((item) => item.fileImportId === selectedCheckbox)?.businessUnit
              }
              userId={rows.find((item) => item.fileImportId === selectedCheckbox)?.userID}
              organizationId={
                rows.find((item) => item.fileImportId === selectedCheckbox)?.organizationId
              }
            />
          </div>
        )}
        {selectedCheckbox !== null &&
          rows.find((item) => item.fileImportId === selectedCheckbox) && (
            <div style={{ marginRight: 10 }}>
              {(() => {
                const fileName =
                  rows.find((item) => item.fileImportId === selectedCheckbox)?.fileName || "";
                const lowerFileName = fileName.toLowerCase();
                const isExcel =
                  lowerFileName.endsWith(".xlsx") ||
                  lowerFileName.endsWith(".xls") ||
                  lowerFileName.endsWith(".xltx");
                const isWord = lowerFileName.endsWith(".doc") || lowerFileName.endsWith(".docx");
                const fileImportId = selectedCheckbox;

                if (isExcel) {
                  return (
                    <ExcelIcon
                      onclick={() => {
                        window.open(
                          `https://eformapi.complytaxforms.com/WHS/${fileImportId}/${fileName}`,
                          "_blank"
                        );
                      }}
                    />
                  );
                } else if (isWord) {
                  return (
                    <WordIcon
                      onclick={() => {
                        window.open(
                          `https://eformapi.complytaxforms.com/WHS/${fileImportId}/${fileName}`,
                          "_blank"
                        );
                      }}
                    />
                  );
                } else {
                  return (
                    <ViewPDf
                      fileImportId={fileImportId}
                      fileName={fileName}
                      userId={rows.find((item) => item.fileImportId === selectedCheckbox)?.userID}
                      organizationId={
                        rows.find((item) => item.fileImportId === selectedCheckbox)?.organizationId
                      }
                    />
                  );
                }
              })()}
            </div>
          )}
        {selectSheet === "Audit" && <ExcelIcon onclick={handleExcelAuditReport} />}

        <div>
          <input
            type="file"
            id="file-upload"
            accept=".xltx"
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <Button
            variant="contained"
            className="review-btn-outline"
            onClick={() => document.getElementById("file-upload").click()}
          >
            Import
          </Button>
        </div>
        <Button
          variant="contained"
          className="review-btn-filled"
          onClick={() => {
            handleSaveChanges(
              rows.find((item) => item.fileImportId === selectedCheckbox).fileImportId,
              rows.find((item) => item.fileImportId === selectedCheckbox).fileImportId
            );
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>Save & Return</span>
        </Button>
      </div>

      {runValidation === true && (
        <div
          onClick={() => {
            setOnClickValue(false);
          }}
          style={{
            marginTop: "6px",
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
            margin: 10,
          }}
        >
          {/* Sheet Tab Bar */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              overflowX: selectSheet === "View Forms" ? "hidden" : "auto",
              scrollbarWidth: "thin",
              "-ms-overflow-style": "scrollbar",
              alignItems: "start",
              padding: "5px 0px 10px 0px",
              justifyContent: "start",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                height: 34,
                marginTop: 10,
                whiteSpace: "nowrap",
                borderBottom: "2px solid #e0e0e0",
                textTransform: "none",
              }}
            >
              {(() => {
                const currentRow = rows.find((item) => item.fileImportId === selectedCheckbox);
                const currentUploadType = currentRow?.uploadType;
                const hasSelfcertTab =
                  currentUploadType === 13 && currentRow?.dataValidation
                    ? (() => {
                        try {
                          return JSON.parse(currentRow.dataValidation)?.hasSelfcertTab;
                        } catch {
                          return false;
                        }
                      })()
                    : false;

                const visibleSheetNames = hasSelfcertTab
                  ? [
                      ...allSheetNames.filter(
                        (n) => n !== "Forms" && n !== "Audit" && n !== "View Forms"
                      ),
                      "Forms",
                      "Forms (Self-Cert)",
                      "Audit",
                      "View Forms",
                    ]
                  : allSheetNames;

                return visibleSheetNames.map((column, index) => {
                  const currentUploadType = rows.find(
                    (item) => item.fileImportId === selectedCheckbox
                  )?.uploadType;

                  let clickableItems = [
                    "Business Entities",
                    "Accounts",
                    "Account Connections",
                    "Audit",
                  ];

                  if (currentUploadType === 13) {
                    const currentRow = rows.find((item) => item.fileImportId === selectedCheckbox);
                    const hasSelfcertTab = currentRow?.dataValidation
                      ? (() => {
                          try {
                            return JSON.parse(currentRow.dataValidation)?.hasSelfcertTab;
                          } catch {
                            return false;
                          }
                        })()
                      : false;

                    clickableItems = [
                      "Business Entities",
                      "Accounts",
                      "Income Codes",
                      "Account Connections",
                      "Forms",
                      ...(hasSelfcertTab ? ["Forms (Self-Cert)"] : []),
                      "Audit",
                    ];
                  }

                  const isViewFormsEnabled = currentUploadType === 11;

                  if (currentUploadType === 13 && column === "Account Balances") {
                    return null;
                  }

                  const isClickable =
                    clickableItems.includes(column) ||
                    (column === "View Forms" && isViewFormsEnabled);

                  return (
                    <div
                      key={column}
                      onClick={() => {
                        if (isClickable) {
                          handleSelectSheetProcess(column);
                        }
                      }}
                      style={{
                        backgroundColor:
                          selectSheet === column && isClickable
                            ? InstaColors.primary
                            : isClickable
                              ? "#E9F5FE"
                              : "#EFF2F4",
                        fontWeight: 400,
                        fontSize: 13,
                        height: 34,
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                        padding: 10,
                        whiteSpace: "nowrap",
                        marginRight: index === visibleSheetNames.length - 1 ? 0 : 6,
                        textAlign: "center",
                        cursor: isClickable ? "pointer" : "not-allowed",
                        display: "flex",
                        alignItems: "center",
                        fontFamily: fontFamily,
                        color: isClickable
                          ? selectSheet === column
                            ? "white"
                            : "#2AA7E0"
                          : "#909096",
                        opacity: 1,
                      }}
                    >
                      {column}
                    </div>
                  );
                });
              })()}
            </div>
          </div>

          {/* Content Area */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100vh - 230px)",
              overflow: "auto",
              overflowX: "auto",
              alignItems: "start",
              padding: "0px 0px 10px 0px",
              justifyContent: "start",
              scrollbarWidth: "thin",
              "-ms-overflow-style": "scrollbar",
            }}
          >
            {selectSheet === "View Forms" ? (
              <>
                {/* Form Type Tabs */}
                <div
                  style={{
                    display: "flex",
                    padding: "10px",
                    fontWeight: "500",
                    fontSize: 14,
                    fontFamily: fontFamily,
                    justifyContent: "space-between",
                  }}
                >
                  {formTypesWithCount.map(([formType, count]) => {
                    const needsDropdown = count > 1;
                    return (
                      <div
                        key={formType}
                        style={{
                          padding: "7px 15px",
                          cursor: "pointer",
                          position: "relative",
                          background: formTypeIndices[formType].includes(selectedIndex)
                            ? InstaColors.primary
                            : "#E9F5FE",
                          borderRadius: "8px",
                          display: "flex",
                          color: formTypeIndices[formType].includes(selectedIndex)
                            ? "white"
                            : InstaColors.primary,
                          alignItems: "center",
                          marginRight: "10px",
                        }}
                      >
                        {needsDropdown ? (
                          <>
                            <select
                              style={{
                                appearance: "none",
                                padding: "5px 10px",
                                backgroundColor: "transparent",
                                color: "black",
                                border: "none",
                                fontWeight: "bold",
                                fontSize: 14,
                                fontFamily: fontFamily,
                                width: "100%",
                                cursor: "pointer",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                opacity: 0,
                              }}
                              value={
                                formTypeIndices[formType].includes(selectedIndex)
                                  ? selectedIndex
                                  : ""
                              }
                              onChange={(e) => setSelectedIndex(parseInt(e.target.value))}
                            >
                              {formTypeIndices[formType].map((originalIndex) => {
                                const formData = extractedValidatedata[originalIndex];
                                let displayValue;

                                if (formData.documentType) {
                                  if (formData.documentType.includes("idDocument")) {
                                    const idType = getIdDocumentType(formData);
                                    let personName = "";

                                    if (formData.FirstName && formData.LastName) {
                                      personName = `${formData.FirstName} ${formData.LastName}`;
                                    } else if (formData.LastName) {
                                      personName = formData.LastName;
                                    } else if (formData.FirstName) {
                                      personName = formData.FirstName;
                                    } else {
                                      personName = `ID ${originalIndex + 1}`;
                                    }

                                    displayValue = personName;
                                  }
                                } else {
                                  displayValue =
                                    formData["Beneficial Owner name"] ||
                                    formData["Name of organization"] ||
                                    formData["W8-BENE-Organization_name"] ||
                                    formData["SC-Individual-First_name"] +
                                      " " +
                                      formData["SC-Individual-Last_name"] ||
                                    `#${originalIndex + 1}`;
                                }

                                return (
                                  <option key={originalIndex} value={originalIndex}>
                                    {displayValue}
                                  </option>
                                );
                              })}
                            </select>

                            <div
                              onClick={() => {
                                setSelectedIndex(formTypeIndices[formType][0]);
                                if (
                                  getFormTypeDisplayName(formType)
                                    .toLowerCase()
                                    .includes("id document")
                                ) {
                                  setViewMode("keyValue");
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                              }}
                            >
                              {getFormTypeDisplayName(formType)}

                              {/* Count Badge on Top Right */}
                              <div
                                style={{
                                  position: "absolute",
                                  top: "-18px",
                                  right: "-35px",
                                  backgroundColor: "#FFF",
                                  color: "#29B6F6",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  boxShadow: "none",
                                }}
                              >
                                {count}
                              </div>
                            </div>
                            <span
                              style={{
                                marginLeft: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              ⌵
                            </span>
                          </>
                        ) : (
                          <div
                            onClick={() => {
                              setSelectedIndex(formTypeIndices[formType][0]);
                              if (
                                getFormTypeDisplayName(formType)
                                  .toLowerCase()
                                  .includes("id document")
                              ) {
                                setViewMode("keyValue");
                              }
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {getFormTypeDisplayName(formType)}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Display Selected Row Data */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    width: "100%",
                    marginTop: "10px",
                    overflow: "hidden",
                    height: "calc(100% - 50px)",
                  }}
                >
                  {/* Left Half - Form Data */}
                  <div
                    style={{
                      width: halfWidth,
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {selectedIndex !== null && (
                      <>
                        {/* Toggle View Hyperlink */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "10px",
                            padding: "0 10px",
                          }}
                        >
                          {isFormTypeWithToggle(extractedValidatedata[selectedIndex]?.formType) && (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setViewMode((prevMode) =>
                                  prevMode === "form" ? "keyValue" : "form"
                                );
                              }}
                              style={{
                                color: InstaColors.primary,
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              {viewMode === "form" ? "Show Details" : "Edit Form"}
                            </a>
                          )}
                        </div>

                        {/* Scrollable Container for Form Data */}
                        <div
                          style={{
                            overflowY: "auto",
                            overflowX: "hidden",
                            height: "calc(100% - 30px)",
                            paddingRight: "10px",
                            width: "100%",
                            maxWidth: "100%",
                          }}
                        >
                          {viewMode === "keyValue" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                // gap: "8px",
                                padding: "10px",
                              }}
                            >
                              {(() => {
                                const fieldOrder = getFormFieldOrder(
                                  extractedValidatedata[selectedIndex]?.formType || ""
                                );

                                const filteredEntries = Object.entries(
                                  extractedValidatedata[selectedIndex]
                                )
                                  .filter(
                                    ([key]) =>
                                      key !== "matchingRow" &&
                                      key !== "formType" &&
                                      key !== "FormType" &&
                                      key !== "Form Type" &&
                                      key !== "viewPdf" &&
                                      key !== "Form number" &&
                                      key !== "Form_number" &&
                                      key !== "Entity Type" &&
                                      key !== "Chapter4Status" &&
                                      key !== "originalIndexValue" &&
                                      key !== "tables" &&
                                      key !== "incomeItems" &&
                                      key !== "isMapDone" &&
                                      key !== "treatyClaims"
                                  )
                                  .filter(
                                    ([key, value]) =>
                                      value !== null &&
                                      value !== undefined &&
                                      value !== "" &&
                                      value !== false
                                  );

                                const sortedEntries = sortByFieldOrder(filteredEntries, fieldOrder);

                                return sortedEntries.map(([key, value], idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      fontSize: 14,
                                      fontFamily: fontFamily,
                                      fontWeight: 400,

                                      padding: "12px 0px",
                                      borderBottom: "0.5px solid #EEEDED",
                                      color: "#3B3B3B",
                                    }}
                                  >
                                    <strong
                                      style={{ fontWeight: 400, color: "#3B3B3B", fontSize: 14 }}
                                    >
                                      {formatFieldNameForDisplay(key)}
                                    </strong>
                                    &nbsp;:{" "}
                                    <span
                                      style={{
                                        color: "#2AA7E0",
                                        fontSize: 14,
                                        fontWeight: 400,
                                      }}
                                    >
                                      {value === true ? "selected" : value}
                                    </span>
                                  </div>
                                ));
                              })()}
                            </div>
                          ) : (
                            <>
                              {getForm(
                                extractedValidatedata[selectedIndex]?.formType,
                                extractedValidatedata[selectedIndex],
                                selectedIndex
                              )}
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Right Half - Selected Row PDF */}
                  <div
                    style={{
                      width: halfWidth,
                      display: "flex",
                      flexDirection: "column",
                      borderLeft: "1px solid #ddd",
                      paddingLeft: "10px",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {selectedIndex !== null && extractedValidatedata[selectedIndex]?.viewPdf && (
                      <div style={{ height: "100%", overflow: "hidden" }}>
                        <SecureDocumentViewer
                          organizationId={
                            rows.find((row) => row.fileImportId === selectedCheckbox)
                              ?.organizationId
                          }
                          userId={rows.find((row) => row.fileImportId === selectedCheckbox)?.userID}
                          fileImportId={selectedCheckbox}
                          fileName={extractedValidatedata[selectedIndex]?.viewPdf?.split("/").pop()}
                          style={{ height: "100%", width: "100%" }}
                          fileType="split_documents"
                          businessunit={
                            rows.find((row) => row.fileImportId === selectedCheckbox)
                              ?.businessUnit || ""
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              // Original rendering for other sheets
              <>
                {/* Error Filter Checkboxes */}
                {selectSheet !== "Audit" &&
                  extractedValidatedata.some((row, i) => rowHasErrors(row, i)) && (
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: "#f5f5f5",
                        borderBottom: "1px solid #e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        position: "sticky",
                        top: 0,
                        left: 0,
                        zIndex: 9,
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontFamily: fontFamily,
                          fontSize: "13px",
                          fontWeight: 400,
                          color: "#333",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={showOnlyErrors}
                          onChange={(e) => setShowOnlyErrors(e.target.checked)}
                          style={{
                            marginRight: "8px",
                          }}
                        />
                        Show Only Rows with Errors
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontFamily: fontFamily,
                          fontSize: "13px",
                          fontWeight: 400,
                          color: "#333",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={showOnlyErrorColumns}
                          onChange={(e) => setShowOnlyErrorColumns(e.target.checked)}
                          style={{
                            marginRight: "8px",
                          }}
                        />
                        Show Only Columns with Errors
                      </label>
                    </div>
                  )}{" "}
                {/* Table Header */}
                <div
                  style={{
                    background: InstaColors.primary,
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                    whiteSpace: "nowrap",
                    textTransform: "none",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  {selectSheet !== "Audit" && (
                    <div
                      style={{
                        width: actionColumnWidth,
                        flexShrink: 0,
                      }}
                    />
                  )}
                  {handleSelectedSheet()
                    .filter((column) => {
                      if (showOnlyErrorColumns) {
                        return columnHasErrors(column.field);
                      }
                      if (hideNonMandatoryColumns) {
                        return (
                          mandatoryColumnFields.has(column.field) ||
                          extractedValidatedata.some(
                            (row) =>
                              row[column.field] !== null &&
                              row[column.field] !== undefined &&
                              row[column.field] !== ""
                          )
                        );
                      }
                      return true;
                    })
                    .map((column, colIndex) => (
                      <div
                        key={column.field}
                        title={column.field}
                        style={{
                          fontSize: 13,
                          whiteSpace: "nowrap",
                          color: "white",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: 140,
                          fontFamily: fontFamily,
                          fontWeight: 400,
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          boxSizing: "border-box",
                          height: 34,
                          display: "flex",
                          alignItems: "center",
                          ...(colIndex === 0
                            ? {
                                position: "sticky",
                                left: 0,
                                zIndex: 101,
                                background: InstaColors.primary,
                              }
                            : {}),
                        }}
                      >
                        {column.header}
                      </div>
                    ))}
                </div>
                {/* Table Rows */}
                {extractedValidatedata
                  .filter((row, index) => {
                    if (showOnlyErrors) {
                      return rowHasErrors(row, index);
                    }
                    return true;
                  })
                  .map((row, index) => (
                    <React.Fragment key={`row-fragment-${index}`}>
                      {selectSheet === "Audit" ? (
                        <div className="validationcolumnRowStyle">
                          {handleSelectedSheet()
                            .filter((column) => {
                              if (showOnlyErrorColumns) {
                                return columnHasErrors(column.field);
                              }
                              if (hideNonMandatoryColumns) {
                                return (
                                  mandatoryColumnFields.has(column.field) ||
                                  extractedValidatedata.some(
                                    (row) =>
                                      row[column.field] !== null &&
                                      row[column.field] !== undefined &&
                                      row[column.field] !== ""
                                  )
                                );
                              }
                              return true;
                            })
                            .map((column, colIndex) => (
                              <div
                                key={column.field}
                                title={row[column.field]}
                                style={{
                                  whiteSpace: "nowrap",
                                  width: 140,
                                  fontSize: 12,
                                  fontFamily: fontFamily,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  paddingLeft: "8px",
                                  paddingRight: "8px",
                                  borderRight: "1px solid #e0e0e0",
                                  boxSizing: "border-box",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  ...(colIndex === 0
                                    ? {
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 9,
                                        background: "white",
                                        borderBottom: "1px solid #e0e0e0",
                                        borderLeft: "1px solid #e0e0e0",
                                      }
                                    : {}),
                                }}
                              >
                                {column.field === "modifiedDate"
                                  ? formatDate(row[column.field])
                                  : row[column.field]}
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div className="validationcolumnRowStyle" style={{}}>
                          {/* Actions column */}
                          {selectSheet !== "Audit" && (
                            <div
                              style={{
                                width: actionColumnWidth,
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRight: "1px solid #e0e0e0",
                                height: "100%",
                              }}
                            >
                              <button
                                title="Delete row"
                                onClick={() => handleDeleteRow(index)}
                                style={{
                                  border: "none",
                                  background: "none",
                                  cursor: "pointer",
                                  padding: "4px",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#d32f2f",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = "#fdecea";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = "none";
                                }}
                              >
                                <img src={deleteIcon} alt="Delete" />
                              </button>
                            </div>
                          )}

                          {/* Data cells */}
                          {handleSelectedSheet()
                            .filter((column) => {
                              if (showOnlyErrorColumns) {
                                return columnHasErrors(column.field);
                              }
                              if (hideNonMandatoryColumns) {
                                return (
                                  mandatoryColumnFields.has(column.field) ||
                                  extractedValidatedata.some(
                                    (r) =>
                                      r[column.field] !== null &&
                                      r[column.field] !== undefined &&
                                      r[column.field] !== ""
                                  )
                                );
                              }
                              return true;
                            })
                            .map((column, colIndex) => {
                              let isMandatoryFiled = false;
                              if (column.field === "UniqueIdentifier" && !row["UniqueIdentifier"]) {
                                isMandatoryFiled = true;
                              }
                              if (column.field === "Entity Type" && !row["Entity Type"]) {
                                isMandatoryFiled = true;
                              }
                              if (
                                row["Entity Type"] === "Individual" ||
                                row["Entity Type"] === "Individual/Sole Proprietor"
                              ) {
                                if (column.field === "FirstName" && !row["FirstName"]) {
                                  isMandatoryFiled = true;
                                }
                                if (column.field === "LastName" && !row["LastName"]) {
                                  isMandatoryFiled = true;
                                }
                              }
                              if (row["Entity Type"] === "Corporation") {
                                if (column.field === "Business Name" && !row["Business Name"]) {
                                  isMandatoryFiled = true;
                                }
                              }
                              if (column.field === "BusinessUnit" && !row["BusinessUnit"]) {
                                isMandatoryFiled = true;
                              }
                              let permCountry = row["Perm. Country"];
                              let mailCountry = row["Mail Country"];

                              const isDropdownColumn = [
                                "Entity Type",
                                "Entity Classification",
                                "Chapter4Status",
                                "FATCA Entity Types",
                                "Form type and revision",
                                "CountryOfBirth",
                                "CountryOfBirthOther",
                                "Country Of Citizenship For Tax Purposes",
                                "Country Of Citizenship For Tax Purposes Other",
                                "Country Of Citizenship For Tax Purposes2",
                                "Country Of Citizenship For Tax Purposes3",
                                "Business Country",
                                "CountryOther",
                                "Domicile Country",
                                "ForeignTaxpayerCountry",
                                "Perm. Country",
                                "Perm. CountryOther",
                                "Mail Country",
                                "Mail CountryOther",
                                "Contact CellNumber Country",
                                "Contact Telephone Country",
                                "Contact Telephone Country2",
                                "VATCountry",
                                "Treaty country",
                                "Foreign Tax Country",
                                "Self-cert Primary Jurisdiction2",
                                "Self-cert Additional Jurisdiction1",
                                "Self-cert Additional Jurisdiction2",
                                "Permanent Country",
                                "Permanent Country Other",
                                "Country of Citizenship",
                                "Country of incorporation or organization",
                                "Mailing address Country",
                                "Mailing address Country Other",
                                "Disregarded entity address Country",
                                ...(selectSheet === "Income Codes" ? ["Income Code"] : []),
                                ...(permCountry === "United States" || permCountry === "Canada"
                                  ? ["State_Province"]
                                  : []),
                                ...(mailCountry === "United States" || mailCountry === "Canada"
                                  ? ["State_Province2"]
                                  : []),
                                ...(selectSheet === "Forms" &&
                                (row["Permanent Country"] === "United States" ||
                                  row["Permanent Country"] === "Canada")
                                  ? ["Permanent State Province"]
                                  : []),
                                ...(selectSheet === "Forms" &&
                                (row["Mailing address Country"] === "United States" ||
                                  row["Mailing address Country"] === "Canada")
                                  ? ["Mailing address State Province"]
                                  : []),
                              ].includes(column.field);

                              let options = [];
                              if (column.field === "Entity Type") options = entityTypeOptions;
                              else if (column.field === "Entity Classification")
                                options = entityClassificationOptions;
                              else if (column.field === "Chapter4Status")
                                options = chapter4StatusOptions;
                              else if (column.field === "FATCA Entity Types")
                                options = chapter4StatusOptions;
                              else if (column.field === "Form type and revision")
                                options = formsTypeList;
                              else if (column.field === "Income Code")
                                options = incomeCodesDropDownList;
                              else if (
                                [
                                  "CountryOfBirth",
                                  "CountryOfBirthOther",
                                  "Country Of Citizenship For Tax Purposes",
                                  "Country Of Citizenship For Tax Purposes Other",
                                  "Country Of Citizenship For Tax Purposes2",
                                  "Country Of Citizenship For Tax Purposes3",
                                  "Business Country",
                                  "CountryOther",
                                  "Domicile Country",
                                  "ForeignTaxpayerCountry",
                                  "Perm. Country",
                                  "Perm. CountryOther",
                                  "Mail Country",
                                  "Mail CountryOther",
                                  "Contact CellNumber Country",
                                  "Contact Telephone Country",
                                  "Contact Telephone Country2",
                                  "VATCountry",
                                  "Treaty country",
                                  "Foreign Tax Country",
                                  "Self-cert Primary Jurisdiction2",
                                  "Self-cert Additional Jurisdiction1",
                                  "Self-cert Additional Jurisdiction2",
                                  "Permanent Country",
                                  "Permanent Country Other",
                                  "Country of Citizenship",
                                  "Country of incorporation or organization",
                                  "Mailing address Country",
                                  "Mailing address Country Other",
                                  "Disregarded entity address Country",
                                ].includes(column.field)
                              )
                                options = countries;
                              else if (column.field === "State_Province")
                                options = countriesWithStates[permCountry] || [];
                              else if (column.field === "State_Province2")
                                options = countriesWithStates[mailCountry] || [];
                              else if (column.field === "Permanent State Province")
                                options = countriesWithStates[row["Permanent Country"]] || [];
                              else if (column.field === "Mailing address State Province")
                                options = countriesWithStates[row["Mailing address Country"]] || [];

                              let isValueInOptions = false;
                              if (isDropdownColumn) {
                                if (
                                  column.field === "State_Province" ||
                                  column.field === "State_Province2" ||
                                  column.field === "Permanent State Province" ||
                                  column.field === "Mailing address State Province"
                                ) {
                                  const country =
                                    column.field === "State_Province"
                                      ? permCountry
                                      : column.field === "State_Province2"
                                        ? mailCountry
                                        : column.field === "Permanent State Province"
                                          ? row["Permanent Country"]
                                          : row["Mailing address Country"];
                                  isValueInOptions = isValidStateForCountry(
                                    row[column.field],
                                    country
                                  );
                                } else {
                                  isValueInOptions =
                                    row[column.field] &&
                                    options.some(
                                      (opt) =>
                                        opt.toLowerCase() ===
                                        String(row[column.field]).toLowerCase()
                                    );
                                }
                              }

                              const formatValidation = validateField(
                                column.field,
                                row[column.field]
                              );
                              const hasFormatError =
                                !formatValidation.isValid &&
                                row[column.field] &&
                                String(row[column.field]).trim() !== "";

                              const matchStatus =
                                selectSheet === "Business Entities"
                                  ? shouldHighlightRow(row[column.field], index)
                                  : false;

                              return (
                                <div
                                  title={
                                    hasFormatError
                                      ? formatValidation.errorMessage
                                      : row[column.field]
                                  }
                                  key={column.field}
                                  onMouseEnter={() => {
                                    setIsHovered(true);
                                    sethoverValue(row[column.field]);
                                    setHoverIndexValue(index);
                                  }}
                                  onMouseLeave={() => {
                                    setIsHovered(false);
                                  }}
                                  onClick={() => {
                                    if (isDropdownColumn) {
                                      setColumnName(column.field);
                                      setEditValue(row[column.field]);
                                      setOldValue(row[column.field]);
                                      setRowIndex(index);
                                      handleSaveEditData();
                                    } else {
                                      setIsModalOpen(true);
                                      setColumnName(column.field);
                                      setOldValue(row[column.field]);
                                      setEditValue(row[column.field]);
                                      setRowIndex(index);
                                    }
                                  }}
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: 140,
                                    display: "flex",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    fontSize: 12,
                                    fontFamily: fontFamily,
                                    backgroundColor:
                                      isMandatoryFiled === true
                                        ? "#f8d7da"
                                        : !["UniqueIdentifier", "BusinessUnit"].includes(
                                              column.field
                                            )
                                          ? matchStatus.highlight === true &&
                                            matchStatus.matchType === "both"
                                            ? "transparent"
                                            : matchStatus.highlight === true &&
                                                matchStatus.matchType === "viewForm"
                                              ? "#FFD580"
                                              : "transparent"
                                          : "transparent",
                                    height: isMandatoryFiled === true ? 31 : 34,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    paddingLeft: "8px",
                                    color:
                                      (isDropdownColumn && !isValueInOptions) || hasFormatError
                                        ? "red"
                                        : "black",
                                    paddingRight: "8px",
                                    borderRight: "1px solid #e0e0e0",
                                    boxSizing: "border-box",
                                    ...(colIndex === 0
                                      ? {
                                          position: "sticky",
                                          left: 0,
                                          zIndex: 9,
                                          borderBottom: "1px solid #e0e0e0",
                                          borderLeft: "1px solid #e0e0e0",
                                          background:
                                            isMandatoryFiled === true
                                              ? "#f8d7da"
                                              : !["UniqueIdentifier", "BusinessUnit"].includes(
                                                    column.field
                                                  )
                                                ? matchStatus.highlight === true &&
                                                  matchStatus.matchType === "both"
                                                  ? "white"
                                                  : matchStatus.highlight === true &&
                                                      matchStatus.matchType === "viewForm"
                                                    ? "#FFD580"
                                                    : "white"
                                                : "white",
                                        }
                                      : {}),
                                  }}
                                >
                                  {isDropdownColumn ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        position: "relative",
                                      }}
                                    >
                                      <select
                                        value={row[column.field]}
                                        onChange={(e) =>
                                          handleDropdownChange(e, row, column.field, index)
                                        }
                                        style={{
                                          width:
                                            matchStatus.matchType === "both"
                                              ? "calc(100% - 10px)"
                                              : "100%",
                                          border: "none",
                                          textOverflow: "ellipsis",
                                          color: isValueInOptions ? "black" : "red",
                                          background:
                                            isMandatoryFiled === true
                                              ? "#f8d7da"
                                              : matchStatus.highlight === true &&
                                                  matchStatus.matchType === "both"
                                                ? "transparent"
                                                : matchStatus.highlight === true &&
                                                    matchStatus.matchType === "viewForm"
                                                  ? "#FFD580"
                                                  : "transparent",
                                          appearance: "none",
                                          WebkitAppearance: "none",
                                          MozAppearance: "none",
                                          outline: "none",
                                          cursor: "pointer",
                                          padding: "0",
                                        }}
                                      >
                                        <option value="" style={{ color: "#999" }}>
                                          {/* Empty option for no selection */}
                                        </option>
                                        {options.map((option) => (
                                          <option
                                            key={option}
                                            style={{ color: "black" }}
                                            value={option}
                                          >
                                            {option}
                                          </option>
                                        ))}
                                        {!options.includes(row[column.field]) &&
                                          row[column.field] && (
                                            <option
                                              key={row[column.field]}
                                              value={row[column.field]}
                                              hidden
                                            >
                                              {row[column.field]}
                                            </option>
                                          )}
                                      </select>
                                      {matchStatus.matchType === "both" && (
                                        <span
                                          style={{
                                            color: "green",
                                            position: "absolute",
                                            right: "2px",
                                            fontSize: "14px",
                                            pointerEvents: "none",
                                          }}
                                        >
                                          ✓
                                        </span>
                                      )}
                                    </div>
                                  ) : row[column.field] !== null && row[column.field] !== "" ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        position: "relative",
                                      }}
                                    >
                                      <span
                                        style={{
                                          maxWidth:
                                            matchStatus.matchType === "both"
                                              ? "calc(100% - 10px)"
                                              : "100%",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {row[column.field]}
                                      </span>
                                      {matchStatus.matchType === "both" && (
                                        <span
                                          style={{
                                            color: "green",
                                            marginLeft: "4px",
                                            fontSize: "14px",
                                            flexShrink: 0,
                                          }}
                                        >
                                          ✓
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    <button
                                      style={{
                                        border: "none",
                                        background: "none",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {row[column.field]}
                                    </button>
                                  )}
                                </div>
                              );
                            })}
                        </div>
                      )}

                      {/* Render matched entities beneath this specific row */}
                      {selectSheet === "Business Entities" &&
                        matchedEntitiesData[index] &&
                        matchedEntitiesData[index].map((matchedEntity, matchIndex) => {
                          const entity = matchedEntity.entity || {};
                          const matchedUniqueId =
                            entity.uniqueIdentifier || matchedEntity.uniqueIdentifier;

                          const isDuplicate = extractedValidatedata.some((existingRow) => {
                            const existingUniqueId =
                              existingRow["Unique Identifier"] ||
                              existingRow.uniqueIdentifier ||
                              existingRow.UniqueIdentifier;
                            return (
                              existingUniqueId &&
                              matchedUniqueId &&
                              existingUniqueId.trim().toLowerCase() ===
                                matchedUniqueId.trim().toLowerCase()
                            );
                          });

                          if (isDuplicate) {
                            return null;
                          }

                          const displayBusinessName = entity.businessName || "";
                          const firstName = entity.firstName || "";
                          const lastName = entity.lastName || "";

                          return (
                            <div
                              key={`match-${index}-${matchIndex}`}
                              className="validationcolumnRowStyle"
                              style={getMatchRowStyle(true)}
                            >
                              <div
                                style={{
                                  width: actionColumnWidth,
                                  flexShrink: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  title="Replace with this entity"
                                  onClick={() => handleAddMatchingRow(index, matchIndex)}
                                  style={{
                                    border: "none",
                                    background: "none",
                                    cursor: "pointer",
                                    padding: "4px",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#2aa7e0",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e3f6fd";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "none";
                                  }}
                                >
                                  <img src={refreshIcon} alt="Replace" />
                                </button>
                              </div>
                              {handleSelectedSheet()
                                .filter((column) => {
                                  if (showOnlyErrorColumns) {
                                    return columnHasErrors(column.field);
                                  }
                                  if (hideNonMandatoryColumns) {
                                    return (
                                      mandatoryColumnFields.has(column.field) ||
                                      extractedValidatedata.some(
                                        (r) =>
                                          r[column.field] !== null &&
                                          r[column.field] !== undefined &&
                                          r[column.field] !== ""
                                      )
                                    );
                                  }
                                  return true;
                                })
                                .map((column, colIndex) => {
                                  let matchedValue = "";

                                  if (
                                    column.field === "Unique Identifier" ||
                                    column.field === "UniqueIdentifier"
                                  ) {
                                    matchedValue =
                                      entity.uniqueIdentifier ||
                                      matchedEntity.uniqueIdentifier ||
                                      "N/A";
                                  } else if (column.field === "Business Name") {
                                    matchedValue = displayBusinessName;
                                  } else if (
                                    column.field === "FirstName" ||
                                    column.field === "First Name"
                                  ) {
                                    matchedValue = firstName;
                                  } else if (
                                    column.field === "LastName" ||
                                    column.field === "Last Name"
                                  ) {
                                    matchedValue = lastName;
                                  } else if (column.field === "Entity Type") {
                                    matchedValue = entity.type || "N/A";
                                  } else if (column.field === "BusinessUnit") {
                                    matchedValue = entity.businessUnit || "N/A";
                                  } else if (column.field === "Entity Classification") {
                                    matchedValue = entity.entityClassification || "";
                                  } else if (
                                    column.field === "Chapter4Status" ||
                                    column.field === "Chapter 4 Status"
                                  ) {
                                    matchedValue = entity.chapter4Status || "";
                                  } else if (column.field === "Perm. Address Line1") {
                                    matchedValue = entity.permanentAddressLine1 || "";
                                  } else if (column.field === "Perm. Address Line2") {
                                    matchedValue = entity.permanentAddressLine2 || "";
                                  } else if (column.field === "City_Town") {
                                    matchedValue = entity.permanentAddressCity || "";
                                  } else if (column.field === "State_Province") {
                                    matchedValue = entity.permanentAddressState || "";
                                  } else if (column.field === "Perm. Country") {
                                    matchedValue = entity.permanentAddressCountry || "";
                                  } else if (column.field === "Zip_PostalCode") {
                                    matchedValue = entity.permanentAddressPostalCode || "";
                                  } else if (column.field === "Mail Address Line1") {
                                    matchedValue = entity.mailingAddressLine1 || "";
                                  } else if (column.field === "Mail Address Line2") {
                                    matchedValue = entity.mailingAddressLine2 || "";
                                  } else if (column.field === "Mail City_Town") {
                                    matchedValue = entity.mailingAddressCity || "";
                                  } else if (column.field === "State_Province2") {
                                    matchedValue = entity.mailingAddressState || "";
                                  } else if (column.field === "Mail Country") {
                                    matchedValue = entity.mailingAddressCountry || "";
                                  } else if (column.field === "Mail Zip_PostalCode") {
                                    matchedValue = entity.mailingAddressPostalCode || "";
                                  } else if (column.field === "ATIN") {
                                    matchedValue = entity.ATIN || "";
                                  } else if (column.field === "EIN") {
                                    matchedValue = entity.EIN || "";
                                  } else if (
                                    column.field === "SSNOrITIN" ||
                                    column.field === "SSN or ITIN"
                                  ) {
                                    matchedValue = entity.SSNOrITIN || "";
                                  } else if (column.field === "PTIN") {
                                    matchedValue = entity.PTIN || "";
                                  } else if (column.field === "QIEIN") {
                                    matchedValue = entity.QIEIN || "";
                                  } else if (column.field === "WP-EIN") {
                                    matchedValue = entity["WP-EIN"] || "";
                                  } else if (column.field === "WT-EIN") {
                                    matchedValue = entity["WT-EIN"] || "";
                                  } else if (
                                    column.field === "ForeignTaxpayerId" ||
                                    column.field === "Foreign Taxpayer ID"
                                  ) {
                                    matchedValue = entity.ForeignTaxpayerId || "";
                                  } else if (column.field === "GIIN") {
                                    matchedValue = entity.GIIN || "";
                                  } else {
                                    matchedValue =
                                      entity[column.field] ||
                                      matchedEntity.form?.[column.field] ||
                                      "";
                                  }

                                  return (
                                    <div
                                      key={column.field}
                                      title={matchedValue}
                                      style={{
                                        whiteSpace: "nowrap",
                                        width: 140,
                                        fontSize: 12,
                                        fontFamily: fontFamily,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        borderRight: "1px solid #e0e0e0",
                                        borderLeft: "1px solid #e0e0e0",
                                        boxSizing: "border-box",
                                        fontWeight: 500,
                                        ...(colIndex === 0
                                          ? {
                                              position: "sticky",
                                              left: 0,
                                              zIndex: 9,
                                              background: "#e8f5e9",
                                              // borderBottom: "1px solid #e0e0e0",
                                            }
                                          : {}),
                                      }}
                                    >
                                      {matchedValue}
                                    </div>
                                  );
                                })}
                            </div>
                          );
                        })}
                    </React.Fragment>
                  ))}
                {selectSheet !== "Audit" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 8,
                      marginTop: 20,
                      alignItems: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      className="review-btn-outline"
                      onClick={handleAddEmptyRow}
                    >
                      Add Row
                    </Button>
                    <Button
                      variant="outlined"
                      className="review-btn-outline"
                      onClick={() => setShowLegend((v) => !v)}
                    >
                      {showLegend ? "Hide Key" : "View Key"}
                    </Button>
                    <Button
                      variant="outlined"
                      className="review-btn-outline"
                      onClick={() => setHideNonMandatoryColumns((v) => !v)}
                    >
                      {hideNonMandatoryColumns ? "Show All Columns" : "Hide Non-Mandatory Columns"}
                    </Button>
                  </div>
                )}
              </>
            )}
            {selectSheet !== "Audit" && selectSheet !== "View Forms" && showLegend && (
              <DataValidationLegend fontFamily={fontFamily} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
